import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const PressReleases = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="TaxZerone® Press Releases: Stay Informed"
          description="Explore the latest news and updates from TaxZerone, your trusted tax e-filing application, on our Press Releases page. Stay informed and up-to-date."
          keywords="TaxZerone Updates, Tax Press Releases, Form 2290 news, Form 990 news, IRS tax filing updates"
          canonical="press-releases/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">Press Releases</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
            >
              Stay updated with the latest news and developments{' '}
              <Link href="/about-us/" sx={{ color: '#0202ff' }}>
                about TaxZerone
              </Link>
              . Below, you will find a collection of our published press
              releases.
            </Typography>
          </Box>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: { xs: 2, md: 5 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            pb={{ xs: 0, sm: 0, md: 2 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 15, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/913025157/taxzerone-urges-nonprofits-to-file-form-990-returns-before-tonight-s-irs-deadline-or-request-a-6-month-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Nonprofits to File Form 990 Returns Before
                    Tonight’s IRS Deadline or Request a 6-Month Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 13, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/911913695/taxzerone-opens-form-2290-pre-filing-for-2026-27-hvut-season-for-truckers-fleets-and-tax-professionals"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Opens Form 2290 Pre-Filing for 2026–27 HVUT Season
                    for Truckers, Fleets, and Tax Professionals
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 11, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/911915571/taxzerone-urges-exempt-organizations-to-file-form-990-before-may-15-2026-or-request-6-month-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Exempt Organizations to File Form 990 Before
                    May 15, 2026 or Request 6-Month Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 30, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/909185279/form-941-q1-2026-deadline-ends-tonight-taxzerone-urges-employers-to-e-file-before-midnight-to-avoid-irs-penalties"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941 (Q1 - 2026) Deadline Ends Tonight: TaxZerone Urges
                    Employers to E-File Before Midnight to Avoid IRS Penalties
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 15, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/905773417/taxzerone-urges-form-1040-filers-who-need-more-time-request-a-6-month-extension-by-filing-form-4868-today"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Form 1040 Filers Who Need More Time: Request
                    a 6-Month Extension by Filing Form 4868 Today
                  </Link>
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 06, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/904117276/taxzerone-reminds-individuals-to-file-form-4868-by-april-15-2026-to-obtain-additional-time-for-filing-form-1040"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Individuals to File Form 4868 by April 15,
                    2026, to Obtain Additional Time for Filing Form 1040
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 02, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/903320209/form-941-filing-for-q1-2026-now-open-taxzerone-reminds-employers-to-file-before-the-april-30-irs-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941 Filing for Q1 2026 Now Open: TaxZerone Reminds
                    Employers to File Before the April 30 IRS Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 31, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/902732823/taxzerone-urges-businesses-final-day-alert-e-file-1099s-w-2g-1098s-3921-3922-aca-forms-or-request-extension-now"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses: Final Day Alert – E-file 1099s,
                    W-2G, 1098s, 3921, 3922 & ACA Forms or Request Extension Now
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 16, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/899682809/final-day-to-file-business-tax-return-taxzerone-urges-businesses-to-file-their-return-today-or-request-an-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Final Day to File Business Tax Return: TaxZerone Urges
                    Businesses to File Their Return Today or Request an
                    Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 10, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/898324026/final-days-to-file-taxzerone-reminds-s-corporations-and-partnerships-to-submit-forms-1120-s-and-1065-by-march-16-2026"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Final Days to File: TaxZerone Reminds S Corporations and
                    Partnerships to Submit Forms 1120-S and 1065 by March 16,
                    2026
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 18, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/893390440/taxzerone-urges-s-corporations-and-partnerships-to-file-forms-1120-s-and-1065-before-the-march-16-2026-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges S Corporations and Partnerships to File
                    Forms 1120-S and 1065 Before the March 16, 2026 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 02, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/888667222/taxzerone-urges-last-minute-filers-w-2-1099-94x-due-tonight-february-2-filing-deadline-expires"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Last-Minute Filers: W-2, 1099, 94X Due
                    Tonight — February 2 Filing Deadline Expires
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 28, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/887284934/taxzerone-reminds-businesses-of-critical-february-2-deadline-for-w-2-1099-and-employment-tax-forms"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Businesses of Critical February 2 Deadline
                    for W-2, 1099, and Employment Tax Forms
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 13, 2026
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/882824866/taxzerone-urges-u-s-businesses-to-file-2025-information-returns-and-94x-forms-ahead-of-irs-deadlines"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges U.S. Businesses to File 2025 Information
                    Returns and 94X Forms Ahead of IRS Deadlines
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  December 15, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/875534999/taxzerone-opens-early-access-for-2025-information-returns-and-employment-tax-filings"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Opens Early Access for 2025 Information Returns
                    and Employment Tax Filings
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 25, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/869783917/taxzerone-opens-filing-for-2025-information-returns-forms-1099-and-w-2"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Opens Filing for 2025 Information Returns (Forms
                    1099 and W-2)
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 17, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/867908190/final-day-to-file-2025-form-990-series-taxzerone-urges-june-30-fy-and-extension-filers-to-submit-by-tonight"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Final Day to File 2025 Form 990 Series – TaxZerone Urges
                    June 30 FY and Extension Filers to Submit by Tonight!
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 14, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/867044231/only-3-days-left-to-file-2025-form-990-series-taxzerone-reminds-fy-june-30-and-extension-filers-to-meet-the-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Only 3 Days Left to File 2025 Form 990 Series – TaxZerone
                    Reminds FY June 30 and Extension Filers to Meet the Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 05, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/864185419/nonprofits-reminded-november-17-2025-deadline-to-file-990-series-returns-for-fiscal-year-ending-june-30-2025"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Nonprofits Reminded: November 17, 2025, Deadline to File 990
                    Series Returns for Fiscal Year Ending June 30, 2025
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  October 29, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/862621372/only-2-days-left-to-file-form-941-for-q3-2025-taxzerone-reminds-employers-to-file-before-the-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Only 2 Days Left to File Form 941 for Q3 2025 – TaxZerone
                    Reminds Employers to File Before the Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 29, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/853535146/filing-season-begins-for-3rd-quarter-2025-form-941-e-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Filing Season Begins for 3rd Quarter 2025 Form 941 E-Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 22, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/851353377/e-file-form-1120-s-with-ease-taxzerone-simplifies-s-corporation-tax-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    E-File Form 1120-S with Ease: TaxZerone Simplifies
                    S-Corporation Tax Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 01, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/845038140/taxzerone-reminder-trucking-businesses-must-file-form-2290-by-september-2-2025"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminder: Trucking Businesses Must File Form 2290
                    by September 2, 2025
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 29, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/835063171/form-941-deadline-nears-taxzerone-urges-businesses-to-file-q2-2025-returns-by-july-31"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941 Deadline Nears! TaxZerone Urges Businesses to File
                    Q2 2025 Returns by July 31
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 01, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/827303080/e-filing-for-irs-form-2290-now-open-for-the-2025-2026-tax-year"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    E-Filing for IRS Form 2290 Now Open for the 2025–2026 Tax
                    Year
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  June 30, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/826897003/taxzerone-announces-filing-season-for-form-941-2nd-quarter-2025"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces Filing Season for Form 941 – 2nd Quarter
                    2025
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 28, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/816730812/taxzerone-urges-timely-filing-of-form-5498-series-before-june-2-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Timely Filing of Form 5498 Series Before
                    June 2 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 19, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/814000866/taxzerone-opens-pre-filing-for-irs-form-2290-for-the-2025-2026-tax-year"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Opens Pre-Filing for IRS Form 2290 for the
                    2025–2026 Tax Year
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 13, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/812129554/taxzerone-urges-nonprofits-to-file-form-990-by-may-15-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Nonprofits to File Form 990 by May 15
                    Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 05, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/809551435/taxzerone-reminds-nonprofits-to-file-990-forms-by-may-15-to-stay-compliant"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Nonprofits to File 990 Forms by May 15 to
                    Stay Compliant
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 30, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/808124079/last-few-hours-left-to-file-form-941-for-q1-of-2025-taxzerone-urges-businesses-to-file-now"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Last Few Hours Left to File Form 941 for Q1 of 2025 -
                    TaxZerone Urges Businesses to File Now
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 14, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/803106709/taxzerone-reminds-u-s-taxpayers-april-15-is-the-deadline-to-file-or-request-a-tax-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds U.S. Taxpayers: April 15 Is the Deadline
                    to File or Request a Tax Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 27, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/797571832/taxzerone-reminds-business-filers-just-a-few-days-left-to-e-file-information-returns-before-the-march-31-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Business Filers: Just a Few Days Left to
                    E-File Information Returns Before the March 31 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 24, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/796610450/taxzerone-reminds-nonprofits-to-file-their-990-forms-before-the-may-15-2025-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Nonprofits to File Their 990 Forms Before
                    the May 15, 2025 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 17, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/794413835/taxzerone-reminds-business-filers-today-is-the-final-day-to-file-s-corp-and-partnership-returns-or-request-an-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Business Filers: Today is the Final Day to
                    File S-Corp and Partnership Returns or Request an Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 11, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/792828516/taxzerone-reminds-business-filers-one-week-left-to-file-s-corporation-and-partnership-tax-forms"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Business Filers: One Week Left to File
                    S-Corporation and Partnership Tax Forms
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 24, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/788666245/taxzerone-reminds-employers-and-insurance-providers-of-the-upcoming-aca-filing-deadlines-for-tax-year-2024"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Employers and Insurance Providers of the
                    Upcoming ACA Filing Deadlines for Tax Year 2024
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 18, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/787080198/taxzerone-reminds-businesses-to-file-form-7004-for-a-tax-filing-extension"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Businesses to File Form 7004 for a Tax
                    Filing Extension
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 29, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/781450986/taxzerone-urges-businesses-to-file-1099-w-2-and-94x-forms-before-the-january-31-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses to File 1099, W-2, and 94x Forms
                    Before the January 31 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 16, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/777545932/2024-tax-filing-season-key-dates-and-deadlines-for-businesses"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    2024 Tax Filing Season: Key Dates and Deadlines for
                    Businesses
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 09, 2025
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/775491189/taxzerone-reminds-businesses-critical-deadline-approaching-for-2024-information-returns-and-employment-tax-forms"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Businesses: Critical Deadline Approaching
                    for 2024 Information Returns and Employment Tax Forms
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  December 24, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/771622137/taxzerone-announces-revised-deadlines-for-beneficial-ownership-information-reporting"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces Revised Deadlines for Beneficial
                    Ownership Information Reporting
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  December 02, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/765392181/tax-season-2024-officially-open-taxzerone-reminds-employers-to-file-1099-and-w-2-forms"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Tax Season 2024 Officially Open: TaxZerone Reminds Employers
                    to File 1099 and W-2 Forms
                  </Link>
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 25, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/763592225/taxzerone-reminds-businesses-of-the-importance-of-filing-boir-with-fincen-before-the-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Businesses of the Importance of Filing
                    BOIR with FinCEN Before the Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  October 29, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/755942949/taxzerone-reminds-employers-of-approaching-form-941-filing-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Employers of Approaching Form 941 Filing
                    Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 30, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/747743984/taxzerone-announces-e-filing-for-form-941-for-the-3rd-quarter-of-2024"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces E-Filing for Form 941 for the 3rd
                    Quarter of 2024
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  August 29, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/739232038/reminder-form-2290-filing-deadline-for-tax-year-2024-2025-is-september-3-2024"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Reminder: Form 2290 Filing Deadline for Tax Year 2024-2025
                    is September 3, 2024
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  August 05, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/733125413/taxzerone-streamlines-non-profit-tax-filing-with-support-for-form-990-t"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Streamlines Non-Profit Tax Filing with Support for
                    Form 990-T
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 30, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/731576042/taxzerone-urges-businesses-to-e-file-form-941-for-q2-2024-before-the-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses to E-File Form 941 for Q2 2024
                    Before the Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 01, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/724302456/taxzerone-announces-e-filing-for-form-2290-for-the-2024-2025-tax-period"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces E-Filing for Form 2290 for the 2024-2025
                    Tax Period
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 01, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/724280411/taxzerone-announces-start-of-e-filing-for-form-941-for-the-second-quarter-of-2024"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces Start of E-Filing for Form 941 for the
                    Second Quarter of 2024
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 29, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/715559407/pre-filing-for-form-2290-now-available-at-taxzerone-for-2024-tax-year"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Pre-Filing for Form 2290 Now Available at TaxZerone for 2024
                    Tax Year
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 15, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/711767352/attention-nonprofits-e-file-form-990-series-with-taxzerone-before-today-s-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Attention Nonprofits: E-File Form 990 Series with TaxZerone
                    Before Today&apos;s Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  May 06, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/709225593/deadline-reminder-nonprofits-urged-to-file-990-forms-to-maintain-tax-exempt-status"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Deadline Reminder: Nonprofits Urged to File 990 Forms to
                    Maintain Tax-Exempt Status
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 30, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/707537591/taxzerone-urges-businesses-file-form-941-today-to-avoid-irs-penalties"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses: File Form 941 Today to Avoid IRS
                    Penalties
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 15, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/703469762/urgent-reminder-e-file-form-7004-and-4868-with-taxzerone-before-today-s-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Urgent Reminder: E-File Form 7004 and 4868 with TaxZerone
                    Before Today&apos;s Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 11, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/702916802/taxzerone-helps-taxpayers-meet-april-15-deadline-with-form-4868-extension-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Helps Taxpayers Meet April 15 Deadline with Form
                    4868 Extension Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 01, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/700256783/taxzerone-announces-support-for-first-quarter-2024-form-941-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces Support for First Quarter 2024 Form 941
                    Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 14, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/695930652/taxzerone-urges-immediate-action-only-one-day-left-to-file-form-7004-and-avoid-penalties"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Immediate Action: Only One Day Left to File
                    Form 7004 and Avoid Penalties!
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 11, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/695067366/important-reminder-from-taxzerone-file-form-7004-now-to-extend-the-business-income-tax-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Important Reminder from TaxZerone: File Form 7004 Now to
                    Extend the Business Income Tax Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 04, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/693143133/attention-taxpayers-streamlined-e-filing-for-irs-extension-deadlines-with-taxzerone-s-enhanced-platform"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Attention Taxpayers: Streamlined E-Filing for IRS Extension
                    Deadlines with TaxZerone&apos;s Enhanced Platform
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 30, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/684709377/taxzerone-encourages-businesses-to-e-file-irs-forms-before-the-january-31st-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Encourages Businesses to E-file IRS Forms Before
                    the January 31st Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 24, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/683513143/taxzerone-urges-businesses-to-e-file-information-returns-by-january-31st-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses to E-File Information Returns by
                    January 31st Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  January 22, 2024
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/682993011/taxzerone-urges-businesses-to-file-forms-941-and-940-before-january-31st-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses to File Forms 941 and 940 Before
                    January 31st Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  November 13, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/668214919/taxzerone-s-reminder-e-file-form-990-ez-and-990-n-before-the-nov-15-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone&apos;s reminder: E-File Form 990-EZ and 990-N
                    before the Nov. 15 deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 22, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/657141723/taxzerone-expands-tax-exempt-filing-services-to-include-form-990-ez-e-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Expands Tax Exempt Filing Services to Include Form
                    990-EZ E-Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  September 20, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/656656053/form-941-e-filing-now-available-in-taxzerone-streamlining-payroll-tax-reporting-for-businesses"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 941 E-Filing Now Available in TaxZerone: Streamlining
                    Payroll Tax Reporting for Businesses
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  August 23, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/651312522/form-2290-deadline-alert-complete-hvut-filing-before-august-31-and-secure-schedule-1-copy"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 2290 Deadline Alert: Complete HVUT Filing Before August
                    31 and Secure Schedule 1 Copy
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  August 14, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/649833173/taxzerone-urges-truckers-to-e-file-form-2290-early-to-beat-the-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Truckers to E-File Form 2290 Early to Beat
                    the Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 26, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/646525294/taxzerone-introduces-automagic2290-simplified-form-2290-e-filing-solution-for-the-2023-tax-year"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Introduces AutoMagic2290: Simplified Form 2290
                    E-Filing Solution for the 2023 Tax Year
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 17, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/644804398/taxzerone-introduces-mobile-app-for-e-filing-form-2290-as-truckers-gear-up-for-tax-season"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Introduces Mobile App for E-Filing Form 2290 as
                    Truckers Gear Up for Tax Season
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 10, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/643938131/taxzerone-encourages-truckers-to-e-file-form-2290-swiftly-with-one-week-gone"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Encourages Truckers to E-File Form 2290 Swiftly
                    with One Week Gone
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  July 03, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/642701398/taxzerone-announces-the-start-of-tax-season-for-e-filing-form-2290-for-the-2023-tax-year"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Announces the Start of Tax Season for E-Filing
                    Form 2290 for the 2023 Tax Year
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  June 1, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/637046506/taxzerone-now-supports-pre-filing-of-form-2290-enabling-truckers-to-stay-ahead-of-their-tax-filing"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Now Supports Pre-Filing of Form 2290, Enabling
                    Truckers to Stay Ahead of Their Tax Filing
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  minHeight: '100%',
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 24, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/629740746/taxzerone-launches-form-2290-e-filing-service-for-truckers"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Launches Form 2290 E-filing Service for Truckers
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 16, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/628228350/taxzerone-urges-businesses-individuals-to-file-income-taxes-before-the-april-18-deadline"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Urges Businesses & Individuals to File Income
                    Taxes Before the April 18 Deadline
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  April 13, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/627707026/taxzerone-now-supports-the-e-filing-of-form-990-n-e-postcard-for-nonprofits"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Now Supports the e-Filing of Form 990-N
                    (e-Postcard) for Nonprofits
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  minHeight: '100%',
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  March 13, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/621845350/taxzerone-reminds-business-owners-of-impending-deadline-to-file-business-income-tax"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Reminds Business Owners of Impending Deadline to
                    File Business Income Tax
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 23, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/618392714/taxzerone-expands-e-filing-services-to-include-irs-extension-form-4868-for-personal-tax-returns"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone Expands E-filing Services to Include IRS Extension
                    Form 4868 for Personal Tax Returns
                  </Link>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 2,
                  borderColor: '#a6a6a6',
                  borderRadius: 5,
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  February 6, 2023
                </Typography>
                <Typography variant="body1">
                  <Link
                    href="https://www.einpresswire.com/article/615416534/taxzerone-llc-launches-an-e-filing-solution-for-business-owners-to-file-irs-form-7004-online"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    TaxZerone LLC Launches an E-Filing Solution for Business
                    Owners to File IRS Form 7004 Online
                  </Link>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to experience the benefits of TaxZerone?
        </Typography>
        <Container maxWidth="md" sx={{ px: 0 }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#f3f3f3',
              mb: 3,
              lineHeight: 1.5,
            }}
          >
            Sign up now and take the first step toward streamlining your tax
            filing process. Join thousands of businesses that have embraced the
            power of e-filing.
          </Typography>
        </Container>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=pressreleases`}
          >
            Sign Up Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default PressReleases;
